import getBalance from './getBalance';
import getQuote from './getQuote';
import deleteAccount from './deleteAccount';

export default {
  getBalance,
  getQuote,
  deleteAccount
};
